module.exports = __webpack_public_path__ + "static/media/scds2019.ad81288b.jpg";